<template>
    <div class="m-2">
        <bread-crumbs :items="items"></bread-crumbs>
        <v-tabs
        grow
        v-model="active_tab"
        >
            <v-tab
            v-for="tab of tabs"
            :key="tab.index"
            :to="tab.href"
            >
            {{tab.name}}
            </v-tab>
        </v-tabs>


    </div>
</template>

<script>
import BreadCrumbs from '@/components/breadCrumbs.vue'
export default{
    components:{BreadCrumbs},
    data() {
        return {
            active_tab:0
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        items: function(){
            return [
                {
                    text: this.lang.system_settings,
                    disabled: true,
                    to: '/settings/system-settings',
                },
            ]
        },
        tabs: function(){
            return [
                {
                    index:0,name: this.lang.system_settings,href:'/settings/system-settings'
                },
                {
                    index:1,name: this.lang.users,href:'/settings/users-settings'
                },
                {
                    index:2,name: this.lang.permissions,href:'/settings/permissions-settings'
                }
            ]
        }
    },
}
</script>